import { Bot, Clock, Rocket, Zap } from "lucide-react";
import { useNavigate } from "react-router-dom";

const ChatBubble = ({ side, children }) => (
  <div className={`max-w-[80%] border-[2.5px] border-brutal-black px-3.5 py-2 text-sm leading-snug font-medium ${side === "right" ? "ml-auto bg-brutal-lime text-brutal-black shadow-brutal-xs" : "bg-white text-brutal-black shadow-brutal-xs"}`}>
    {children}
  </div>
);

export const AiHighlight = () => {
  const navigate = useNavigate();
  return (
    <section data-testid="ai-highlight" className="relative py-24 sm:py-32 bg-brutal-pink border-y-[3px] border-brutal-black overflow-hidden">
      <div className="absolute inset-0 opacity-10 pointer-events-none" style={{ backgroundImage: "repeating-linear-gradient(45deg, #0A0A0A 0 2px, transparent 2px 18px)" }} />
      <div className="relative max-w-7xl mx-auto px-5 sm:px-8 lg:px-12 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div>
          <div className="inline-flex items-center gap-2 bg-brutal-black border-[2.5px] border-brutal-black px-3.5 py-1.5">
            <Zap size={14} strokeWidth={3} className="text-brutal-yellow" />
            <span className="font-mono text-[11px] font-bold uppercase tracking-widest text-white">IA NO WHATSAPP</span>
          </div>
          <h2 className="mt-6 font-heading text-4xl sm:text-5xl lg:text-6xl tracking-tight text-brutal-black uppercase leading-[0.95]">
            Tem cliente<br />que NÃO abre<br />
            <span className="bg-brutal-yellow border-[3px] border-brutal-black px-3 py-0.5 inline-block shadow-brutal -rotate-2 mt-2">link nenhum.</span>
          </h2>
          <p className="mt-7 text-base sm:text-lg text-brutal-black leading-relaxed max-w-lg font-medium">
            Por isso a IA do Pede é Fácil entra em ação: o cliente manda mensagem, ela conversa, anota item por item, confirma endereço e joga tudo no seu painel. <span className="bg-white border-2 border-brutal-black px-1.5 font-bold">Você não perde a venda.</span>
          </p>
          <ul className="mt-9 space-y-4">
            <li className="flex items-start gap-3.5">
              <span className="bg-brutal-yellow border-[2.5px] border-brutal-black p-2.5 shadow-brutal-xs shrink-0">
                <Bot size={22} strokeWidth={2.5} className="text-brutal-black" />
              </span>
              <div>
                <p className="font-heading text-lg text-brutal-black uppercase">Atende como gente</p>
                <p className="text-sm text-brutal-black font-medium">Entende "quero aquela pizza grande sem cebola".</p>
              </div>
            </li>
            <li className="flex items-start gap-3.5">
              <span className="bg-brutal-lime border-[2.5px] border-brutal-black p-2.5 shadow-brutal-xs shrink-0">
                <Clock size={22} strokeWidth={2.5} className="text-brutal-black" />
              </span>
              <div>
                <p className="font-heading text-lg text-brutal-black uppercase">24h, 7 dias por semana</p>
                <p className="text-sm text-brutal-black font-medium">Casa cheia, madrugada ou feriado: nenhum pedido fica sem resposta.</p>
              </div>
            </li>
          </ul>
          <button data-testid="ai-register-cta" onClick={() => navigate("/login", { state: { register: true } })} className="mt-10 bg-brutal-black text-white border-[3px] border-brutal-black px-7 py-4 font-heading uppercase tracking-tight text-base shadow-brutal-md hover:translate-y-[-3px] hover:shadow-brutal-lg active:translate-y-[2px] active:shadow-brutal-sm transition-all inline-flex items-center gap-2">
            <Rocket size={20} strokeWidth={3} />Testar com IA grátis
          </button>
        </div>
        <div data-testid="ai-chat-mock" className="relative bg-brutal-cream border-[3px] border-brutal-black p-5 sm:p-7 shadow-brutal-xl">
          <div className="absolute -top-4 -right-4 bg-brutal-lime border-[2.5px] border-brutal-black px-3 py-1 shadow-brutal-sm rotate-3">
            <p className="font-mono text-[10px] font-bold uppercase tracking-widest text-brutal-black">◉ ONLINE</p>
          </div>
          <div className="flex items-center gap-3 pb-4 border-b-[2.5px] border-brutal-black border-dashed">
            <div className="w-11 h-11 border-[2.5px] border-brutal-black bg-brutal-pink flex items-center justify-center font-heading text-xl text-white shadow-brutal-xs">P</div>
            <div>
              <p className="font-heading text-base text-brutal-black uppercase">Pizzaria do Marcos</p>
              <p className="font-mono text-[10px] uppercase tracking-widest text-brutal-black font-bold">IA ATIVA</p>
            </div>
          </div>
          <div className="pt-5 space-y-3">
            <ChatBubble side="right">Boa noite, vcs tão abertos? Quero uma pizza</ChatBubble>
            <ChatBubble side="left">Boa noite! 😊 Tô sim. Qual sabor prefere? As mais pedidas são calabresa, frango c/ catupiry e portuguesa.</ChatBubble>
            <ChatBubble side="right">Manda uma calabresa grande sem cebola</ChatBubble>
            <ChatBubble side="left">Anotado: 1 pizza grande calabresa, sem cebola — R$ 54,90. Entrega ou retirada?</ChatBubble>
            <ChatBubble side="right">Entrega, Rua das Acácias 120</ChatBubble>
            <ChatBubble side="left">Perfeito! Pedido confirmado ✅ Chega em até 45 min.</ChatBubble>
          </div>
        </div>
      </div>
    </section>
  );
};
